// extracted by mini-css-extract-plugin
module.exports = {"nav":"header_nav__7sJ38","logo":"header_logo__vVwaF","profile":"header_profile__B35Pv","login":"header_login__e8_yb"};